const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

export function getStoredAccessToken(): string | null {
	return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getStoredRefreshToken(): string | null {
	return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setStoredTokens(accessToken: string, refreshToken: string): void {
	localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
	localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

export function clearStoredTokens(): void {
	localStorage.removeItem(ACCESS_TOKEN_KEY);
	localStorage.removeItem(REFRESH_TOKEN_KEY);
}

/** Fires callback when another tab changes tokens in localStorage. */
export function onStorageChange(
	callback: (accessToken: string | null, refreshToken: string | null) => void
): () => void {
	const handler = (e: StorageEvent) => {
		if (e.key === ACCESS_TOKEN_KEY || e.key === REFRESH_TOKEN_KEY || e.key === null) {
			callback(localStorage.getItem(ACCESS_TOKEN_KEY), localStorage.getItem(REFRESH_TOKEN_KEY));
		}
	};
	window.addEventListener("storage", handler);
	return () => window.removeEventListener("storage", handler);
}
